const initItems = () => {
	const grid = document.querySelector('.coworker-archive__grid');

	if (grid) {
		const dropdownToggles = document.querySelectorAll('.coworker-tease__dropdown-toggle');

		if (dropdownToggles.length > 0) {
			dropdownToggles.forEach(toggle => {
				toggle.addEventListener('click', e => {
					e.preventDefault();

					const target = toggle.getAttribute('data-target');
					const targetElement = document.getElementById(target);

					// Check if the clicked dropdown is already open
					const isAlreadyOpen = targetElement.classList.contains('is-open');

					// Close all dropdowns
					dropdownToggles.forEach(otherToggle => {
						const otherTarget = otherToggle.getAttribute('data-target');
						const otherTargetElement = document.getElementById(otherTarget);
						otherTargetElement.classList.remove('is-open');
					});

					// If the clicked dropdown was not already open, open it
					if (!isAlreadyOpen) {
						targetElement.classList.add('is-open');
					}
				});
			});
		}
	}
};

document.addEventListener('facetwp-loaded', () => {
	initItems();
});

